import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchIN12aDispatch = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetIN12aDispatch`);

  return response.data.data;
};

export const useIN12aDispatch = (enabled = true) =>
  useQuery({
    queryKey: ["IN12aDispatch"],
    queryFn: () => fetchIN12aDispatch(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    refetchInterval: 120 * 1000, // ← auto-update every 2 minute
  });
